const maxSurveysForUserProject = 3
const areasTexts = [
  {
    survey: 'spiritual life',
    chart: 'Spiritual life',
    description: 'not only religion but also meditation, time for reflection, music, nature, search for beauty…'
  },
  {
    survey: 'cultural activity',
    chart: 'Cultural activity',
    description: 'reading books, watching movies, visiting museums, going to theatre, concerts...'
  },
  {
    survey: 'professional growth',
    chart: 'Professional growth',
    description: 'reading books, attending conventions, seminars, workshops, continuing education…'
  },
  {
    survey: 'social life and friends',
    chart: 'Social life & Friends',
    description: 'meeting friends, talking on the phone, joint activities, going out or inviting for dinner…'
  },
  {
    survey: 'work',
    chart: 'Work',
    description: 'focus and concentration on actual work, answering emails and notifications, conflict resolution, personal relationships, time management…'
  },
  {
    survey: 'children figures in your life',
    chart: 'Children',
    description: 'not only children or grandchildren but also anybody else that depends from you emotionally or financially…'
  },
  {
    survey: 'love',
    chart: 'Love',
    description: 'not only your partner but also more general love for others, volunteering, nature…'
  },
  {
    survey: 'body and health care',
    chart: 'Body & Health care',
    description: 'physical activities, outdoor activities, regular medical checkups, self care habits…'
  },
  {
    survey: 'sexual life',
    chart: 'Sexual life',
    description: 'not only sex but also body pleasures, massage, intimacy…'
  },
  {
    survey: 'food',
    chart: 'Food',
    description: 'variety and quality of food, attention to preparation, tasting new food, budget for eating out…'
  },
  {
    survey: 'rest',
    chart: 'Rest',
    description: 'quality and quantity of sleep, naps, breaks at work, using relaxing techniques...'
  },
  {
    survey: 'your home',
    chart: 'Home',
    description: 'cleaning, reordering, decorating, paying bills and taxes, insurance…'
  },
  {
    survey: 'your family of origin',
    chart: 'Family of origin',
    description: 'caretaking, administration, conflict resolution…'
  },
  {
    survey: 'financial stability',
    chart: 'Financial stability',
    description: 'management of income, expenses, savings, investment plans…'
  }
]

const icabody = {
  getSurveyAreaName (areaNumber) {
    if (areaNumber < 1 || areaNumber > areasTexts.length) return null
    return areasTexts[areaNumber].survey
  },
  getChartAreaName (areaNumber) {
    if (areaNumber < 1 || areaNumber > areasTexts.length) return null
    return areasTexts[areaNumber].chart
  },
  getSurveyAreas () {
    let areas = []
    areasTexts.forEach((element) => {
      areas.push(element.survey)
    })
    return areas
  },
  getChartAreas () {
    let areas = []
    areasTexts.forEach((element) => {
      areas.push(element.chart)
    })
    return areas
  },
  getDescriptionAreas () {
    let areas = []
    areasTexts.forEach((element) => {
      areas.push(element.description)
    })
    return areas
  },
  getMaxSurveysForUserProject () {
    return maxSurveysForUserProject
  }
}

export default icabody